import { generateMedia } from "styled-media-query";
import MediaBorders from 'constants/media-borders';

export const CustomMedia = generateMedia(MediaBorders);
export default CustomMedia;


// WEBPACK FOOTER //
// ./src/util/custom-media-query.js